import { render, staticRenderFns } from "./IncidentWorkflowSummary.vue?vue&type=template&id=6d39b8fc&"
import script from "./IncidentWorkflowSummary.vue?vue&type=script&lang=js&"
export * from "./IncidentWorkflowSummary.vue?vue&type=script&lang=js&"
import style0 from "./IncidentWorkflowSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports